import { render, staticRenderFns } from "./CreateNewModal.vue?vue&type=template&id=5de38748&scoped=true&lang=pug"
import script from "./CreateNewModal.vue?vue&type=script&lang=js"
export * from "./CreateNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de38748",
  null
  
)

export default component.exports